<template>
  <Layout
    username="Supervisor"
    current-page="Add Sales Agent"
    link-to-edit="/sup-dashboard/edit-profile"
  >
    <template slot="menuItems">
      <li
        v-for="{ title, icon, path } in menu"
        :key="title"
        class="nav-item"
      >
        <MenuItems
          :menu-item="title"
          :icon-menu="icon"
          :to-where="path"
        />
      </li>
    </template>
    <template slot="side info">
      <router-link
        class="side-info"
        to="/supervisor/agents"
      >
        View agents
      </router-link>
    </template>
    <template slot="content">
      <div
        class="jumbotron justify-content-center d-sm-none d-md-block col-lg-8"
      >
        <ValidationObserver v-slot="{ invalid }">
          <form @submit.prevent="onSubmit">
            <ValidationProvider
              v-for="input in inputs"
              :key="input.name"
              v-slot="{ errors }"
              mode="aggressive"
              :rules="input.rules"
              persist
            >
              <label :for="input.name">{{ input.label }}</label>
              <input
                v-model="input.value"
                :name="input.name"
                :type="input.type"
                :placeholder="input.placeholder"
                class="form-control"
                :class="{ 'is-invalid': errors[0] }"
              >
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </ValidationProvider>
            <ul>
              <li 
                v-for="dbError of dbErrors"
                :key="dbError"
                class="custom-error"
              >
                {{ dbError }}
              </li>
            </ul>
            <div class="d-flex flex-row-reverse mt-3">
              <primary-button
                type="submit"
                classes="btn btn-primary p2"
                title="Add Agent"
                :loading="isSubmitting"
                :disabled="invalid"
              />
            </div>
          </form>
        </ValidationObserver>
      </div>
    </template>
  </Layout>
</template>

<script>
import Layout from "../../components/Layout";
import MenuItems from "../../components/MenuItems";
import PrimaryButton from "../../components/Buttons/PrimaryButton.vue";
import { mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver} from "vee-validate";

export default {
  name: "Addcompany",
  components: {
    Layout,
    MenuItems,
    PrimaryButton,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      inputs: [
        {
          label: "Name",
          name: "agentName",
          type: "text",
          rules: "required",
          value: "",
          placeholder: "John Doe",
        },
        {
          label: "username",
          name: "username",
          type: "text",
          rules: "required",
          value: "",
          placeholder: "jdoe12",
        },
        {
          label: "Phone Number",
          name: "phoneNumber",
          type: "tel",
          rules: "required|phone|digits:10",
          value: "",
          placeholder: "0788888888",
        },
        {
          label: "Address",
          name: "address",
          type: "text",
          rules: "required|min:7",
          value: "",
          placeholder: "KG number st",
        },
        {
          label: 'Password',
          name:'passowrd',
          type:'password',
          rules:'required',
          value:''
        }
      ],
      menu: [
        {
          title: "Dashboard",
          icon: "fa fa-chart-line",
          path: "/supervisor",
        },
        {
          title: "Add Sales Agent",
          icon: "fa fa-plus",
          path: "/supervisor/agents/new",
        },
        {
          title: "Sales",
          icon: "fa fa-table",
          path: "/supervisor/sales",
        },
        {
          title: "Agents",
          icon: "fa fa-users",
          path: "/supervisor/agents",
        },
      ],
      dbErrors:{

      }
    };
  },
  computed: {
    ...mapGetters({ isSubmitting: "agent/isSubmitting" }),
  },
  methods: {
    onSubmit() {
      this.dbErrors = {}
      let name = this.inputs[0]?.value;
      let username = this.inputs[1]?.value;
      let phoneNumber = this.inputs[2]?.value;
      let address = this.inputs[3]?.value;
      let password = this.inputs[4]?.value
      this.$store
        .dispatch("agent/saveAgent", {
          name,
          username,
          phoneNumber,
          address,
          password
        })
        .then(() => {
          this.clear();
          this.$router.push({ name: "viewagents" });
        })
        .catch((err) => {
          this.dbErrors = err
        });
    },
    clear: function () {
      this.$store.dispatch("alert/clear");
    },
  },
};
</script>

<style scoped>
.nav-item {
  cursor: pointer;
}

.nav-item .nav-link:hover {
  color: #8bc34a;
}

.side-info {
  color: #8bc34a;
}

.side-info:hover {
  color: #5a9216;
}
</style>
